module.exports = __webpack_public_path__ + "static/media/addtweets.b0450fe2.svg";